<ion-item lines="none" *ngIf="label" class="ion-text-wrap">
  <ion-label >{{label}}</ion-label>
</ion-item>
<ion-item lines="none" id="signContainer">
    <ion-button class="clearSignBtn" color="danger" fill="clear" slot="end" size="large" (click)="clear()" *ngIf="!disabled && !disableButton" [disabled]="disableButton">
      <ion-icon name="close-circle-outline" slot="icon-only"></ion-icon>
    </ion-button>
  <signature-pad #signature (drawStart)="drawStart()" (drawEnd)="drawComplete()" *ngIf="!dataUrl"></signature-pad>
  <ion-img [src]="'data:' + dataUrl" *ngIf="dataUrl"></ion-img>
</ion-item>